// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"56a8c8fc","703":"5e544a5f"}[chunkId] + ".chunk.js";
};